import { buildUrl } from '../../../utils/api';

export const fetchSiteServicePeriodsURL = (siteId: string) =>
  buildUrl(`/api/v2/adm/service-management/service-periods/site/${siteId}`);
